import converter from '../../utils/converter';
import * as uamWebSocketEventTypes from '../../consts/uam/uamWebSocketEventTypes';
import * as iotConnectionService from '../iot/iotConnectionService';
import * as uamWebSocketActionTypes from '../../consts/uam/uamWebSocketActionTypes';
import iotService from '../iot/iotService';
import {selectIsHolderAssetId} from '../../state/selectors/uamData';
import {
    setAutoCleanInProgress,
    setFindMyDeviceStatus,
    setFwuInProgress,
    setResetDeviceInProgress,
    setUamWebSocketAlive,
    setUpdateSettingsInProgress,
} from '../../state/slices/iotData';
import * as uamActionStatusTypes from '../../consts/uam/uamActionStatusTypes';
import errorService from '../errors/errorService';
import {MW_ERRORS} from '../../consts/app/mwErrors';
import {selectIsAutoCleanInProgress, selectIsFindMyDeviceInProgress} from '../../state/selectors/iotData';
import findMyDeviceStatuses from '../../consts/device/findMyDeviceStatuses';

const PONG = 'pong';
const proceedMessage = async (message, isHolder) => {
    const data = converter.stringToJson(message.data) || {};
    const {eventType, request, error, assetId, status, requestId, isSBLMode, events, response, associatedDevices} =
        data || {};

    if (response === PONG) {
        setUamWebSocketAlive(isHolder, true);
        return;
    }

    //const uamError = getErrorMapping(error);

    switch (eventType) {
        case uamWebSocketEventTypes.CONNECTION_STATUS_CHANGE:
            iotConnectionService.proceedConnectionChange(status, assetId, isSBLMode, associatedDevices);

            break;
        case uamWebSocketEventTypes.INFERENCE_COMPLETED:
            //const {inferenceName} = data || {};

            //await proceedInferenceCompleted(assetId, inferenceName);
            break;
        case uamWebSocketEventTypes.ASYNC_REQUEST:
            const {action, value} = request || {};
            const actionStatus = iotService.proceedAction({
                status,
                requestId,
                assetId,
                action,
            });

            if (!actionStatus && action !== uamWebSocketActionTypes.PROGRESS) return;

            switch (action) {
                case uamWebSocketActionTypes.REFRESH_INFO:
                    const isHolder = selectIsHolderAssetId(assetId);

                    await iotConnectionService.proceedRefreshInfo(isHolder, actionStatus, error);
                    break;
                case uamWebSocketActionTypes.RUN_COMMAND:
                    const isAutoCleanInProgress = selectIsAutoCleanInProgress();

                    if (isAutoCleanInProgress) {
                        await proceedAutoClean(actionStatus, assetId, error);
                        return;
                    }

                    const isFindMyDeviceInProgress = selectIsFindMyDeviceInProgress();

                    if (isFindMyDeviceInProgress) {
                        await proceedFindDevice(actionStatus, assetId, error, new Date());
                        return;
                    }

                    break;
                case uamWebSocketActionTypes.DATA_COLLECTION:
                case uamWebSocketActionTypes.COLLECT_DATA:
                    //await proceedSynchronizeDataCollection(actionStatus, assetId);
                    break;
                case uamWebSocketActionTypes.UPDATE_SETTING:
                    updateDeviceSettings(actionStatus, assetId, error);
                    break;
                case uamWebSocketActionTypes.PROGRESS:
                    // Ignore progress from IOT, progress value is set directly on MW side
                    break;
                case uamWebSocketActionTypes.FIRMWARE_UPGRADE:
                    proceedFwu(actionStatus, assetId, error);
                    break;
                case uamWebSocketActionTypes.RESET_DEVICE:
                    proceedResetDevice(actionStatus, assetId, error);
                    break;
                default:
                    break;
            }
            break;
        case uamWebSocketEventTypes.DEVICE_EVENT:
            if (!events) return;

            events.forEach((event) => {
                iotService.updateDeviceCharacteristics(event);
            });
            break;
        default:
            break;
    }
};
/*
const proceedSynchronizeDataCollection = async (status, assetId) => {
    const state = getState();
    const isDeviceReady = selectIsDeviceReady(state);
    const isHolder = selectIsHolderAssetId(assetId);
    const dataCollectionType = dataCollectionService.getCurrentDataCollectionType();

    if (status === uamActionStatusTypes.SUCCESS) {
        dataCollectionService.setDataCollectionFlowReceived({isReceived: true, isHolder, dataCollectionType});
        dataCollectionService.setDataCollectionFlowInProgress(false, dataCollectionType);

        //for diagnostic data collection flow should wait for INFERENCE_COMPLETED event
        if (dataCollectionType === dataCollectionTypes.DATA_COLLECTION_DIAGNOSTIC) {
            advanceDiagnosticService.checkDiagnosticResult(isHolder);
            return;
        }

        if (dataCollectionType === dataCollectionTypes.DATA_COLLECTION_GLOBAL) {
            amplitudeDataCollectionTracking.trackGlobalDataCollectionCompleted(isHolder);
        }

        dispatch(addYapLastDataCollectionTime());
    } else if (status === uamActionStatusTypes.CANCELED) {
        dataCollectionService.setDataCollectionFlowInProgress(false, dataCollectionType);

        if (dataCollectionType === dataCollectionTypes.DATA_COLLECTION_GLOBAL) {
            amplitudeDataCollectionTracking.trackGlobalDataCollectionCompleted(isHolder);
        }
    } else if (isDeviceReady) {
        await uamClientService.proceedSynchronizeAllData(isHolder, true, dataCollectionType);
    } else {
        if (dataCollectionType === dataCollectionTypes.DATA_COLLECTION_DIAGNOSTIC) {
            advanceDiagnosticService.setDiagnosticFailed(isHolder);
            return;
        }
        dataCollectionService.setDataCollectionFlowInProgress(false, dataCollectionType);
    }
};

const proceedInferenceCompleted = async (assetId, inferenceName) => {
    const isAdvanceDiagnostic = selectIsDiagnosticFlow(getState());

    if (!isAdvanceDiagnostic) return;

    const isHolder = selectIsHolderAssetId(assetId);
    const dataCollectionType = dataCollectionService.getCurrentDataCollectionType();
    const isReceived = dataCollectionService.getIsDataCollectionReceived(
        dataCollectionTypes.DATA_COLLECTION_DIAGNOSTIC,
        isHolder
    );

    if (dataCollectionType !== dataCollectionTypes.DATA_COLLECTION_DIAGNOSTIC && !isReceived) return;

    if (!inferenceName) return advanceDiagnosticService.setInferenceCompleted(isHolder);

    const diagnosticData = await uamClientService.getInferenceInfo(assetId, inferenceName);

    if (!diagnosticData) return advanceDiagnosticService.setInferenceCompleted(isHolder);

    const logData = JSON.stringify(diagnosticData);

    log.info(
        `InferenceCompleted for isHolder: ${isHolder} inferenceName: ${inferenceName} assetId: ${assetId} with data: ${logData}`
    );

    advanceDiagnosticService.clearFailedAttempts(isHolder);

    const {result: diagnosticResult} =
        diagnosticData?.data?.items?.find((x) => x.inferenceName === inferenceName) || {};
    const {L0 = null, L1 = null, device_state} = diagnosticResult ? converter.stringToJson(diagnosticResult) || {} : {};

    let deviceState = device_state ? device_state.toLowerCase() : null;
    let inferenceCode = L0;
    let inferenceCode_L1 = L1;

    const isSuccessFlowForInferenceCode = advanceDiagnosticService.getIsSuccessFlowForInferenceCode(
        isHolder,
        deviceState,
        inferenceCode
    );

    if (isSuccessFlowForInferenceCode) {
        //if success flow reset error code
        inferenceCode = null;
        inferenceCode_L1 = null;
        deviceState = null;
    }

    const isMaxSuccessfulAttempts = advanceDiagnosticService.checkMaxSuccessfulAttempts(isHolder, inferenceCode);

    if (isMaxSuccessfulAttempts) {
        //if the maximum number of attempts is exceeded - set a success flow (null)
        inferenceCode = null;
        inferenceCode_L1 = null;
        deviceState = null;
    }

    advanceDiagnosticService.setDiagnosticPartResult({deviceState, inferenceCode, inferenceCode_L1, isHolder});
    if (inferenceCode) {
        amplitudeADTracking.trackADCompleted({isHolder, inferenceCode});
    }
    advanceDiagnosticService.checkDiagnosticResult(isHolder);
};*/

const proceedFwu = (status, assetId, error) => {
    const isHolder = selectIsHolderAssetId(assetId);
    const customError = getCustomError(status, assetId, error);

    setFwuInProgress(isHolder, false, customError);
};

const proceedResetDevice = (status, assetId, error) => {
    const isHolder = selectIsHolderAssetId(assetId);
    const customError = getCustomError(status, assetId, error);

    setResetDeviceInProgress(isHolder, false, customError);
};

const proceedFindDevice = async (status, assetId, error, startTimeTS) => {
    const customError = getCustomError(status, assetId, error);
    const findMyDeviceStatus = customError ? findMyDeviceStatuses.ERROR : findMyDeviceStatuses.SUCCESS;

    setFindMyDeviceStatus(findMyDeviceStatus, customError, startTimeTS);
};

const proceedAutoClean = async (status, assetId, error) => {
    const customError = getCustomError(status, assetId, error);

    setAutoCleanInProgress(false, customError);
};

const updateDeviceSettings = (status, assetId, error) => {
    const isHolder = selectIsHolderAssetId(assetId);
    const customError = getCustomError(status, assetId, error);

    setUpdateSettingsInProgress(isHolder, false, customError);
};

const getCustomError = (status, assetId, error) => {
    const isSuccess = status === uamActionStatusTypes.SUCCESS;
    const errorMessage = JSON.stringify(error) || 'Error is not defined in IoT response';

    return isSuccess ? undefined : errorService.createError(MW_ERRORS.ERROR_IOT_CUSTOM, errorMessage);
};

export default {
    proceedMessage,
    // proceedSynchronizeDataCollection,
};
